import EventEmitter from 'src/helpers/EventEmitter' 
import axios from 'axios'

const Events = {

  Success: 'Events.Success',
  Error: 'Events.Error',

  Speech: {
    Success: 'Events.Speech.Success',
    Error: 'Events.Speech.Error'
  },

  NaturalLang: {
    Success: 'Events.NaturalLang.Success',
    Error: 'Events.NaturalLang.Error'
  }
}

const url = 'https://us-central1-project-doom-666.cloudfunctions.net';
const ENDPOINTS = {
  SPEECH_TO_TEXT : url + '/speechToText',
  NATURAL_LANG : url + '/naturalLanguage'
}

class GCPService {

  constructor() {
    this.config = {}
    Object.assign(this, EventEmitter);
  }


  // SPEECH TO TEXT - - - - - - - - - - - - - - - - - 

  speechToText(base64) {
    let data = { 
      'base64': base64 
    }
    axios.post(ENDPOINTS.SPEECH_TO_TEXT, data, { 
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(this.onSpeechSuccess)
    .catch(this.onSpeechError);
  }

  onSpeechSuccess = (response) => {
    let transcription = response.data.text; 
    this.emit(Events.Speech.Success, transcription);
  }

  onSpeechError = (error) =>  {
    console.log(error);
    this.emit(Events.Speech.Error, error);
    this.emit(Events.Error, error);
  }


  // NATURAL LANG - - - - - - - - - - - - - - - - - 

  naturalLanguage = (transcription, uid) => { 
    let data = { 
      'uid': uid,
      'transcription': transcription 
    }
    axios.post(ENDPOINTS.NATURAL_LANG, data,{ 
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(this.onNaturalLangSuccess)
    .catch(this.onNaturalLangError);
  }

  onNaturalLangSuccess = (response) => {
    let data = {
      score: response.data.sentiment.documentSentiment.score,
      magnitude: response.data.sentiment.documentSentiment.magnitude
    };
    this.emit(Events.NaturalLang.Success, data)
    this.emit(Events.Success, data);
  }

  onNaturalLangError = (error) =>{
    console.log(error);
    this.emit(Events.NaturalLang.Error, error);
    this.emit(Events.Error, error);
  }

}

let service = new GCPService()
service.Events = Events
window.GCPService = service
export default service
